import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useContext } from 'react';
import UserContext from '../../../context/UserContext';
import { loginAlert } from '../../common/CustomAlert';

const pathNames = {
	'/': 'PT00',
	'/community': 'PT01',
	'/information': 'PT02',
	'/placeRank': 'PT04',
	'/consulting': 'PT00',
}

const linkActiveClass = to => {
    if (to === '/') {
        if (window.location.hash === '#/') return 'active'
    } else {
        if (window.location.hash.startsWith(`#${to}`)) return 'active';
    }
    return '';
}

const BottomNav = () => {
    const location = useLocation();
	const navigate = useNavigate();
	const { user } = useContext(UserContext);
	const [searchParams] = useSearchParams();
	const handleWriteBtn = () => {
		const postType = searchParams.get('postType') || pathNames[location.pathname];
        if (!user.userId) return loginAlert('로그인이 필요합니다다.');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const endfix = postType === 'PT00' ? '1' : '0';
        const navPostType = postType.length === 4 ? postType + endfix : postType;
        navigate(`/post/write?postType=${navPostType}`);
    }
    return (
		<>
			<div class="vh-mobile-nav-wrap">
				<ul class="mobile-nav">
					<li className={linkActiveClass('/community')}>
						<Link to="/community">
							<i class="icon icon-menu-01"></i>
							<span>커뮤니티</span>
						</Link>
					</li>
					<li className={linkActiveClass('/information')}>
						<Link to="/information">
							<i class="icon icon-menu-02"></i>
							<span>정보광장</span>
						</Link>
					</li>
					<li className={linkActiveClass('/')}>
						<Link to="/">
							<i class="icon icon-menu-03"></i>
							<span>광장</span>
						</Link>
					</li>
					<li className={linkActiveClass('/placeRank')}>
						<Link to="/placeRank">
							<i class="icon icon-menu-03"></i>
							<span>순위조회</span>
						</Link>
					</li>
					<li className={linkActiveClass('/consulting')}>
						<Link to="/consulting">
							<i class="icon icon-menu-04"></i>
							<span>대행서비스</span>
						</Link>
					</li>
				</ul>
			</div>
			{ !location.pathname.includes('/expert') && <div class="vh-floating-wrap" id="floating">
                <div class="vw-inner">
                    <ul>
                        <li>
                            <a title="글쓰기" onClick={handleWriteBtn} className="whiteBtn">
                                글쓰기
                            </a>
                        </li>
                    </ul>
                </div>
            </div>}
		</>
    )
}

export default BottomNav;